import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { confirmAsync } from './lib/confirmAsync';
import { initSentry, Sentry } from './lib/sentry';

// Initialize Sentry BEFORE React renders so first-paint errors are captured.
initSentry();

// Force dark mode
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<div className="p-8 text-rose-400">Something went wrong. Refresh to retry.</div>}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for offline support
serviceWorkerRegistration.register({
  onSuccess: () => console.log('[App] Service Worker registered successfully'),
  onUpdate: async (registration) => {
    console.log('[App] New version available. Please refresh.');
    // confirmAsync falls back to window.confirm if ConfirmHost isn't mounted
    // yet — safe even if the SW emits the update event during early boot.
    const ok = await confirmAsync({
      title: 'New version available',
      description: 'Reload now to get the latest features and bug fixes.',
      confirmLabel: 'Reload',
      cancelLabel: 'Later',
      testIdPrefix: 'sw-update-confirm',
    });
    if (ok && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
